<template>
  <div class="row">
    <div class="col-12">
      <div class="row d-flex justify-content-center">
        <div class="col-10 mt-2" v-if="this.stepsFiltered.length > 0">
          <el-card
            shadow="always"
            class="py-3 px-5"
            style="border-radius: 10px; position: relative; align-items: center"
            v-loading="loading"
          >
            <div class="d-flex justify-content-center mb-4">
              <div
                v-for="(stepOption, index) in stepsFiltered.filter(
                  (x) => x.key != 'completed' && x.key != 'business-contact'
                )"
                :key="index"
                class="text-center"
                style="width: 200px"
              >
                <div
                  class="status-requirements"
                  style="position: relative"
                  :class="[
                    {
                      'pending-action':
                        !stepOption.steps.includes(stepId) &&
                        onboardingAccount.is_completed == false,
                    },
                    {
                      pending:
                        stepOption.steps.includes(stepId) &&
                        onboardingAccount.is_completed == false,
                    },
                    {
                      approved:
                        Math.max(...stepOption.steps) < stepId ||
                        onboardingAccount.is_completed == true,
                    },
                  ]"
                >
                  <i
                    class="fa fa-check-circle"
                    style="
                      font-size: 65px;
                      position: absolute;
                      left: -2px;
                      top: -2px;
                    "
                  ></i>
                </div>
                <div
                  class="mt-2 status-requirements-text"
                  :class="[
                    {
                      'pending-action':
                        !stepOption.steps.includes(stepId) &&
                        onboardingAccount.is_completed == false,
                    },
                    {
                      pending:
                        stepOption.steps.includes(stepId) &&
                        onboardingAccount.is_completed == false,
                    },
                    {
                      approved:
                        Math.max(...stepOption.steps) < stepId ||
                        onboardingAccount.is_completed == true,
                    },
                    {
                      'font-weight-bold':
                        stepOption.steps.includes(stepId) &&
                        onboardingAccount.is_completed == true,
                    },
                  ]"
                >
                  {{ stepOption.title }}
                </div>
              </div>
            </div>

            <div
              class="flex-grow-1 onboarding-card d-flex flex-column justify-content-center"
            >
              <component
                :is="
                  componentsListFiltered.find((x) => x.step_id == stepId)
                    .component
                "
                :initial_lead="lead"
                :business-types="businessTypes"
                :profile_type_id="initial_onboarding_account.profile_type_id"
                :onboarding-account="onboardingAccount"
                :business-roles="businessRoles"
                @update-lead="updateLead"
                @create-lead="createLead"
                :key="updateCount"
                class="h-100 bg-white"
              ></component>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    initial_onboarding_account: {
      type: Object,
    },
    businessTypes: {
      type: Array,
    },
    businessRoles: {
      type: Array,
    },
    signedUrl: {
      type: String,
    },
    signedUrlCreate: {
      type: String,
    },
  },

  data() {
    return {
      onboardingAccount: this.initial_onboarding_account,
      lead: this.initial_onboarding_account.lead
        ? this.initial_onboarding_account.lead
        : {
            abn: "",
            acn: "",
            name: "",
            business_type_id: "",
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            address: "",
            is_alpa: "",
            is_action_plus: "",
            extra_attributes: "",
            documents: [],
            guarantors: [],
            properties: [],
            is_completed: false,
            year_established: "",
            profile_type_id: this.initial_onboarding_account.profile_type_id,
          },
      stepId: 0,
      loading: false,
      stepsFiltered: [],
      componentsListFiltered: [],
      loading: false,
      updateCount: 0,
      componentsList: [
        {
          step_id: 0,
          component: "onboarding-business-data",
          profiles: [1, 2, 3, 4],
          key: "business",
        },
        {
          step_id: 1,
          component: "onboarding-business-documents-data",
          profiles: [1, 2, 3, 4],
          key: "business-documents",
        },
        {
          step_id: 2,
          component: "onboarding-business-contact-data",
          profiles: [1, 2, 3, 4],
          key: "business-data",
        },
        {
          step_id: 3,
          component: "onboarding-contact-details",
          profiles: [1, 2, 3, 4],
          key: "contacts",
        },
        {
          step_id: 4,
          component: "onboarding-property",
          profiles: [2, 3, 4],
          key: "properties",
        },
        {
          step_id: 5,
          component: "onboarding-feedlot-data",
          profiles: [3, 4],
          key: "feedlot",
        },
        {
          step_id: 6,
          component: "onboarding-idenfy-link",
          profiles: [1, 2, 3, 4],
          key: "idenfy",
        },
        {
          step_id: 7,
          component: "onboarding-turnover-data",
          profiles: [1],
          key: "turnover",
        },
        {
          step_id: 8,
          component: "onboarding-completed",
          profiles: [1, 2, 3, 4],
          key: "completed",
        },
      ],
      steps: [
        {
          steps: [0, 1, 2],
          title: "Business",
          profiles: [1, 2, 3, 4],
        },
        {
          steps: [3],
          title: "Contact Details",
          profiles: [1, 2, 3, 4],
        },
        {
          steps: [4],
          title: "Property",
          profiles: [2, 3, 4],
        },
        {
          steps: [5],
          title: "Feedlot Data",
          profiles: [3, 4],
        },
        {
          steps: [6],
          title: "ID Verification",
          profiles: [1, 2, 3, 4],
        },
        {
          steps: [7],
          title: "Turnover",
          profiles: [1],
        },
      ],
    };
  },
  mounted() {
    this.stepsFiltered = this.steps.filter((x) =>
      x.profiles.includes(this.initial_onboarding_account.profile_type_id)
    );
    this.componentsListFiltered = this.componentsList.filter((x) =>
      x.profiles.includes(this.initial_onboarding_account.profile_type_id)
    );
    if (this.onboardingAccount.is_completed == false) {
      this.stepId = this.componentsList.findIndex(
        (x) => x.key == this.onboardingAccount.step
      );
    } else this.stepId = 0;
  },
  methods: {
    updateLead(lead, action) {
      this.lead = lead;
      if (action == "save") {
        this.onSubmit(false);
        return;
      }
      let index = this.componentsListFiltered.findIndex(
        (x) => x.step_id == this.stepId
      );
      let stepId = null;
      if (action == "next") {
        stepId = this.componentsListFiltered[index + 1].step_id;
        // if business type is not trust or partnership and there is no cp document, go to next step
        if (
          stepId == 1 &&
          (![3, 4].includes(this.lead.business_type_id) ||
            this.lead.onboarding_media.filter(
              (x) =>
                [44, 43].includes(x.media_collection_id) && x.is_cp == false
            ).length > 0)
        ) {
          stepId = 2;
        }
      } else if (action == "prev") {
        stepId = this.componentsListFiltered[index - 1].step_id;
        // if business type is not trust or partnership and there is no cp document, go to next step
        if (
          stepId == 1 &&
          (![3, 4].includes(this.lead.business_type_id) ||
            this.lead.onboarding_media.filter(
              (x) =>
                [44, 43].includes(x.media_collection_id) && x.is_cp == false
            ).length > 0)
        ) {
          stepId = 0;
        }
      }
      this.stepId = stepId;
      if (this.stepId == 8 && this.onboardingAccount.is_completed == false) {
        this.onSubmit(true);
      }
    },
    convertToFormData(complete) {
      let onboardingAccount = {
        id: this.onboardingAccount.id,
        step: this.componentsListFiltered.find((x) => x.step_id == this.stepId)
          .key,
        is_completed: complete == true ? 1 : 0,
        abn: this.lead.abn || "",
        acn: this.lead.acn || "",
        name: this.lead.name || "",
        business_type_id: this.lead.business_type_id || "",
        first_name: this.lead.first_name || "",
        last_name: this.lead.last_name || "",
        email: this.lead.email || "",
        phone: this.lead.phone || "",
        is_alpa: this.lead.is_alpa || 0,
        is_action_plus_tpa: this.lead.is_action_plus_tpa || 0,
        extra_attributes: this.lead.extra_attributes || "",
        guarantors: this.lead.guarantors.map((g) => {
          return {
            id: g.id || "",
            first_name: g.first_name || "",
            last_name: g.last_name || "",
            email: g.email || "",
            phone: g.phone || "",
            extra_attributes: g.extra_attributes || "",
            postal_address: g.postal_address || "",
            is_signatory: g.is_signatory || "",
            is_access_required: g.is_access_required || "",
            business_role_id: g.business_role_id || "",
          };
        }),
        properties: this.lead.properties.map((p) => {
          return {
            id: p.id || "",
            pic: p.pic || "",
            name: p.name || "",
            owning_entity: p.owning_entity || "",
            phone: p.phone || "",
            email: p.email || "",
            owner_legal_name: p.owner_legal_name || "",
            town: p.town || "",
            region_id: p.region_id || "",
            property_type: p.property_type || "",
            cattle_average_daily_gain: p.cattle_average_daily_gain || "",
            sheep_average_daily_gain: p.sheep_average_daily_gain || "",
            is_nlis_confirmed: p.is_nlis_confirmed || "",
            pic_type: p.pic_type || "",
          };
        }),
      };

      let formData = new FormData();
      let val = null;
      for (let key in onboardingAccount) {
        if (onboardingAccount.hasOwnProperty(key)) {
          if (Array.isArray(onboardingAccount[key])) {
            onboardingAccount[key].forEach((item, index) => {
              for (let keyArray in item) {
                if (typeof item[keyArray] === "object") {
                  formData.append(
                    `${key}[${index}][${keyArray}]`,
                    JSON.stringify(item[keyArray])
                  );
                } else {
                  val = item[keyArray];
                  if (item[keyArray] === true) val = 1;
                  formData.append(`${key}[${index}][${keyArray}]`, val);
                }
              }
            });
          } else if (typeof onboardingAccount[key] === "object") {
            formData.append(`${key}`, JSON.stringify(onboardingAccount[key]));
          } else {
            val = onboardingAccount[key];
            if (onboardingAccount[key] === true) val = 1;
            formData.append(`${key}`, val);
          }
        }
      }
      if (this.lead.documents) {
        this.lead.documents.forEach((document) => {
          formData.append(`attachments[]`, document.raw, document.name);
          formData.append(
            `media_collection_id[]`,
            document.media_collection_id ? document.media_collection_id : ""
          );
          formData.append(`pic[]`, document.pic ? document.pic : "");
        });
      }

      return formData;
    },
    onSubmit(complete) {
      this.loading = true;
      let formData = this.convertToFormData(complete);
      formData.append("_method", "PUT");
      axios
        .post(this.signedUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        })
        .then((result) => {
          this.onboardingAccount = result.data;
          this.lead = result.data.lead;
          this.updateCount++;
          this.$message.success(complete == true ? "Sent" : "Saved");
        })
        .catch((error) => {
          console.log(error);
          this.errors = error.response.data.errors;
          this.$message({
            type: "error",
            message: "Some fields are required",
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    createLead() {
      this.loading = true;
      axios
        .post(this.signedUrlCreate, {
          agency_lead_id: this.onboardingAccount.lead_id,
        })
        .then((result) => {
          window.location.href = result.data.signed_form_url;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.$message({
            type: "error",
            message: "Some fields are required",
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
@media (min-width: 992px) {
  .onboarding-card {
    min-height: 400px;
  }
}
</style>
